module.exports = __webpack_public_path__ + "img/facebook.e1b6c1a1.svg";